import { FC, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Badge, Button, Dropdown, List, Tag, Tooltip } from 'antd'
import {
	BellOutlined,
	CheckOutlined,
	LogoutOutlined,
	ThunderboltFilled
} from '@ant-design/icons'
import { authStore } from '../store/auth'
import { notificationStore } from '../store/notification'
import { RNLogout } from '../helpers/routeNames'
import '../styles/AppLayout.scss'

const ROLE_LABELS: Record<string, string> = {
	admin: 'Администратор',
	worker: 'Работник',
	supervisor: 'Супервайзер'
}

const ROLE_COLORS: Record<string, string> = {
	admin: 'blue',
	worker: 'green',
	supervisor: 'purple'
}

export const AppHeader: FC = () => {
	const { user } = authStore()
	const navigate = useNavigate()
	const {
		notifications,
		unreadCount,
		isFetched,
		fetchNotifications,
		markRead,
		markAllRead
	} = notificationStore()

	useEffect(() => {
		if (user && !isFetched) {
			fetchNotifications()
		}
	}, [user, isFetched, fetchNotifications])

	const displayName = user
		? [user.lastName, user.firstName].filter(Boolean).join(' ')
		: ''

	const notificationMenu = (
		<div
			style={{
				width: 320,
				background: '#fff',
				borderRadius: 8,
				boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
				overflow: 'hidden'
			}}>
			<div
				style={{
					padding: '10px 16px',
					borderBottom: '1px solid #f0f0f0',
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center'
				}}>
				<span style={{ fontWeight: 600 }}>Уведомления</span>
				{unreadCount > 0 && (
					<Button
						type="link"
						size="small"
						icon={<CheckOutlined />}
						onClick={(e) => {
							e.stopPropagation()
							markAllRead()
						}}>
						Прочитать все
					</Button>
				)}
			</div>
			<List
				style={{ maxHeight: 360, overflowY: 'auto' }}
				dataSource={notifications.slice(0, 20)}
				locale={{ emptyText: 'Нет уведомлений' }}
				renderItem={(n) => (
					<List.Item
						style={{
							padding: '8px 16px',
							background: n.isRead
								? 'transparent'
								: '#f0f7ff',
							cursor: 'pointer'
						}}
						onClick={() => !n.isRead && markRead(n.id)}
						extra={
							!n.isRead && (
								<span
									style={{
										width: 8,
										height: 8,
										borderRadius: '50%',
										background: '#1677ff',
										display: 'inline-block'
									}}
								/>
							)
						}>
						<List.Item.Meta
							description={
								<>
									<div
										style={{
											fontWeight: n.isRead
												? 'normal'
												: 600,
											fontSize: 13,
											color: '#262626'
										}}>
										{n.message}
									</div>
									<div
										style={{
											fontSize: 11,
											color: '#8c8c8c',
											marginTop: 2
										}}>
										{new Date(
											n.createdAt
										).toLocaleString('ru')}
									</div>
								</>
							}
						/>
					</List.Item>
				)}
			/>
		</div>
	)

	return (
		<header className="app-header">
			<Link to="/" className="app-header-brand">
				<div className="app-header-logo">
					<ThunderboltFilled />
				</div>
				<span className="app-header-title">Учёт реле</span>
			</Link>

			<div className="app-header-user">
				{user && (
					<>
						<span className="app-header-username">
							{displayName || user.username}
						</span>

						<Tag
							className="app-header-role"
							color={
								ROLE_COLORS[user.role] ?? 'default'
							}>
							{ROLE_LABELS[user.role] ?? user.role}
						</Tag>

						<Dropdown
							overlay={notificationMenu}
							trigger={['click']}
							placement="bottomRight">
							<Badge count={unreadCount} size="small">
								<Button
									type="text"
									size="small"
									icon={<BellOutlined />}
								/>
							</Badge>
						</Dropdown>

						<Tooltip title="Выйти">
							<Button
								className="app-header-logout"
								type="text"
								size="small"
								icon={<LogoutOutlined />}
								onClick={() => navigate(RNLogout)}
							/>
						</Tooltip>
					</>
				)}
			</div>
		</header>
	)
}